import React from 'react';
import { Field, Modal } from '../../components/ui';

const findField = (fields, key) => fields.find(field => field.key === key) || { key, label: key };

// Desktop event form (Super Admin): two-column modal.
export default function EventFormDesktop({ vm }) {
  const { open, editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!open) return null;

  const adminMode = values.EventAdminMode || 'Existing User';
  const eventName = findField(fields, 'EventName');
  const eventType = findField(fields, 'EventTypeId');
  const adminModeField = findField(fields, 'EventAdminMode');
  const existingAdmin = findField(fields, 'EventAdminUserId');
  const newAdminName = findField(fields, 'EventAdminName');
  const newAdminMobile = findField(fields, 'EventAdminMobileNumber');
  const newAdminPassword = findField(fields, 'EventAdminPassword');
  return (
    <Modal
      title={`${editing ? 'Edit' : 'Add'} Event`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <div className="form-grid">
        <div style={{ gridColumn: '1 / -1' }}>
          <Field
            label="Event Name"
            value={values.EventName}
            required
            onChange={(value) => setField(eventName, value)}
          />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <Field
            label="Event Type"
            type="select"
            value={values.EventTypeId}
            options={eventType.options}
            required
            onChange={(value) => setField(eventType, value)}
          />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <Field
            label="Event Admin"
            type="select"
            value={adminMode}
            options={adminModeField.options}
            required
            onChange={(value) => setField(adminModeField, value)}
          />
        </div>
        {adminMode === 'Existing User' ? (
          <div style={{ gridColumn: '1 / -1' }}>
            <Field
              label="Existing User"
              type="select"
              value={values.EventAdminUserId}
              options={existingAdmin.options}
              required
              onChange={(value) => setField(existingAdmin, value)}
            />
          </div>
        ) : (
          <>
            <div>
              <Field
                label="New User Name"
                value={values.EventAdminName}
                required
                onChange={(value) => setField(newAdminName, value)}
              />
            </div>
            <div>
              <Field
                label="New User Mobile"
                value={values.EventAdminMobileNumber}
                required
                onChange={(value) => setField(newAdminMobile, value)}
              />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <Field
                label="New User Password"
                value={values.EventAdminPassword || '1234'}
                onChange={(value) => setField(newAdminPassword, value)}
              />
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}
